// import React from 'react';
// import SubframeCore from "@subframe/core";
// import { Progress } from "@/subframe/components/Progress";
// import { IconButton } from "@/subframe/components/IconButton";
// import moment from "moment";
// import MessageComponent from "../MessageComponent";
// import { useSelector } from 'react-redux';
// import { useMediaDownload } from "../media/MediaDownloadHook";
// import { RootState } from '../../redux/store';

// interface RecipientMessage {
//   message_id?: string;
//   id?: string;
//   recipient?: string;
//   created_at: string;
//   recipient_payload?: {
//     entry: [{
//       changes: [{
//         value: {
//           messages: [{
//             type: "text" | "video" | "document" | "image" | "audio" | "button";
//             text?: {
//               body: string;
//             };
//             video?: {
//               caption?: string;
//               id?: number;
//             };
//             document?: {
//               caption?: string;
//               id?: number;
//               filename?: string;
//               mime_type?: string;
//             };
//             image?: {
//               caption?: string;
//               id?: number;
//             };
//             audio?: {
//               voice: boolean;
//             };
//           }]
//         }
//       }]
//     }]
//   }
// }

// interface RecipientProps {
//   message: RecipientMessage;
//   scrollRef: React.RefObject<HTMLDivElement>;
// }

// const Recipient: React.FC<RecipientProps> = ({ message, scrollRef }) => {
//   const messageData = message.recipient_payload?.entry?.[0]?.changes?.[0]?.value?.messages?.[0];

//     const system_user_id = useSelector((state: RootState) => state.auth.system_user_id);
//     const { downloadMedia, isDownloading } = useMediaDownload();

//     // Helper function to get media ID from different sources
//     const getMediaId = () => {
//       return message.recipient_payload?.entry?.[0]?.changes?.[0]?.value?.messages?.[0]?.image?.id ||
//              message.recipient_payload?.entry?.[0]?.changes?.[0]?.value?.messages?.[0]?.video?.id ||
//              message.recipient_payload?.entry?.[0]?.changes?.[0]?.value?.messages?.[0]?.document?.id;
//     };
    

//   const handleDownloadClick = async (e: React.MouseEvent) => {
//       e.preventDefault();
//       e.stopPropagation();
      
//       const mediaId = getMediaId();
//       console.log('Download clicked:', { mediaId, system_user_id });
      
//       if (!system_user_id) {
//         console.error('System user ID not available');
//         return;
//       }
      
//       if (!mediaId) {
//         console.error('Media ID not available');
//         return;
//       }
      
//       try {
//         const result = await downloadMedia(mediaId, system_user_id);
//         console.log('Download result:', result);
//       } catch (error) {
//         console.error('Download error:', error);
//       }
//     };

//   // Handle basic text message or when no specific message type is provided
//   if (!messageData && message.recipient) {
//     return (
//       <div ref={scrollRef} className="flex w-full items-start justify-start gap-2 mt-2">
//         <div className="flex flex-col items-start gap-2 rounded-lg bg-default-background px-4 py-3 shadow-sm max-w-[70%]">
//           <MessageComponent message={message.recipient} />
//           <div className="flex items-end gap-1">
//             <span className="text-caption font-caption text-subtext-color">
//               {moment(message.created_at).local().format("hh:mm A")}
//             </span>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   switch (messageData?.type) {
//     case 'video':
//       return (
//         <div ref={scrollRef} className="flex w-full flex-col items-start justify-start gap-2 mt-4">
//           <div className="flex grow shrink-0 basis-0 flex-col items-end justify-center rounded-lg border border-solid border-neutral-border bg-[#ffffffff] shadow-sm max-w-[70%]">
//             <div className="flex w-full flex-col items-start gap-2 px-1 py-1">
//               <div className="relative flex w-full flex-col items-center justify-center gap-2 rounded-t-md bg-neutral-200 px-1 py-1">
//                 <img
//                   className="h-36 w-full flex-none rounded-t-sm border-b-2 border-solid border-neutral-border object-cover blur-md"
//                   src={`/api/media/${getMediaId()}`}
//                   alt="video preview"
//                 />
//                 <button 
//                   onClick={handleDownloadClick}
//                   disabled={isDownloading}
//                   className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 backdrop-blur-md transition-transform duration-300 hover:scale-110 shadow-lg"
//                 >
//                   <SubframeCore.Icon
//                 className="text-heading-1 font-heading-1 text-neutral-600 p-50"
//                 name={isDownloading ? "FeatherLoader" : "FeatherArrowDownCircle"}
//               />
//                 </button>
//               </div>
//             </div>
//             <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-1 px-4 pt-2 pb-1">
//               <MessageComponent message={message.recipient || ''} />
//               <div className="flex w-full items-center justify-end gap-1">
//                 <span className="text-caption font-caption text-subtext-color">
//                   {moment(message.created_at).local().format("hh:mm A")}
//                 </span>
//                 <div className="flex grow shrink-0 basis-0 items-center justify-end gap-1">
//                   <SubframeCore.Icon
//                     className="text-monospace-body font-monospace-body text-subtext-color"
//                     name="FeatherVideo"
//                   />
//                   <span className="text-caption font-caption text-subtext-color">
//                     Video message
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       );

//     case 'document':
//       return (
//         <div ref={scrollRef} className="flex w-full flex-col items-start justify-center gap-4 mt-4">
//           <div className="flex grow shrink-0 basis-0 flex-col items-end justify-center rounded-lg border border-solid border-neutral-border bg-[#ffffffff] shadow-sm max-w-[70%]">
//             <div className="flex w-full flex-col items-start px-1 py-1">
//               <div className="relative flex w-full flex-col items-center justify-center gap-2 rounded-t-md bg-neutral-200 px-1 py-1">
//                 <img
//                   className="h-36 w-full flex-none rounded-t-sm border-b-2 border-solid border-neutral-border object-cover blur-md"
//                   src={`/api/media/${getMediaId()}`}
//                   alt="document preview"
//                 />
//                 <button 
//                   onClick={handleDownloadClick}
//                   disabled={isDownloading}
//                   className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 backdrop-blur-md transition-transform duration-300 hover:scale-110 shadow-lg"
//                 >
//                   <SubframeCore.Icon
//                 className="text-heading-1 font-heading-1 text-neutral-600 p-50"
//                 name={isDownloading ? "FeatherLoader" : "FeatherArrowDownCircle"}
//               />
//                 </button>
//               </div>
//               <div className="flex w-full items-center gap-2 rounded-b-md bg-neutral-200 px-2 pt-1 pb-2.5">
//                 <SubframeCore.Icon
//                   className="text-heading-1 font-heading-1 text-default-font"
//                   name="FeatherFile"
//                 />
//                 <div className="flex flex-col items-start">
//                   <span className="text-body-bold font-body-bold text-default-font">
//                     {messageData.document?.filename || "Document"}
//                   </span>
//                   <span className="text-caption font-caption text-subtext-color">
//                     {messageData.document?.mime_type?.split('/')[1].toUpperCase()}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-1 px-4 pt-2 pb-1">
//               <MessageComponent message={message.recipient || ''} />
//               <span className="text-caption font-caption text-subtext-color">
//                 {moment(message.created_at).local().format("hh:mm A")}
//               </span>
//             </div>
//           </div>
//         </div>
//       );

//     case 'image':
//       return (
//         <div ref={scrollRef} className="flex w-full flex-col items-start justify-center gap-4 mt-4">
//           <div className="flex grow shrink-0 basis-0 flex-col items-end justify-center rounded-lg border border-solid border-neutral-border bg-[#ffffffff] shadow-sm max-w-[70%]">
//             <div className="flex w-full flex-col items-start gap-2 px-1 py-1">
//               <div className="relative flex w-full flex-col items-center justify-center gap-2 rounded-t-md bg-neutral-200 px-1 py-1">
//                 <img
//                   className="h-36 w-full flex-none rounded-t-sm border-b-2 border-solid border-neutral-border object-cover blur-md"
//                   src={`/api/media/${getMediaId()}`}
//                   alt="image preview"
//                 />
//                 <button 
//                   onClick={handleDownloadClick}
//                   disabled={isDownloading}
//                   className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 backdrop-blur-md transition-transform duration-300 hover:scale-110 shadow-lg"
//                 >
//                   <SubframeCore.Icon
//                 className="text-heading-1 font-heading-1 text-neutral-600 p-50"
//                 name={isDownloading ? "FeatherLoader" : "FeatherArrowDownCircle"}
//               />
//                 </button>
//               </div>
//             </div>
//             <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-1 px-4 pt-2 pb-1">
//               <MessageComponent message={message.recipient || ''} />
//                 <div className="flex w-full items-center justify-end gap-1">
//                     <span className="text-caption font-caption text-subtext-color">
//                         {moment(message.created_at).local().format("hh:mm A")}
//                     </span>
//                     <div className="flex grow shrink-0 basis-0 items-center justify-end gap-1">
//                         <SubframeCore.Icon
//                         className="text-monospace-body font-monospace-body text-subtext-color"
//                         name="FeatherImage"
//                         />
//                         <span className="text-caption font-caption text-subtext-color">
//                             Image message
//                         </span>
//                     </div>
//                 </div>
//             </div>
//           </div>
//         </div>
//       );

//     case 'audio':
//       return (
//         <div ref={scrollRef} className="flex w-full items-start justify-start gap-2 mt-2">
//           <div className="flex w-80 flex-col items-start gap-2 rounded-md border border-solid border-neutral-border bg-white px-4 py-3 shadow-sm">
//             <div className="flex w-full items-center gap-2">
//               <IconButton
//                 size="small"
//                 icon="FeatherPlay"
//               />
//               <div className="flex grow shrink-0 basis-0 items-center gap-2">
//                 <Progress />
//                 <span className="text-caption-bold font-caption-bold text-subtext-color">
//                   0:45
//                 </span>
//               </div>
//             </div>
//             <div className="flex w-full items-center gap-2">
//               <SubframeCore.Icon
//                 className="text-body font-body text-subtext-color"
//                 name="FeatherMic"
//               />
//               <span className="grow shrink-0 basis-0 text-body font-body text-default-font">
//                 Voice message
//               </span>
//               <span className="text-caption font-caption text-subtext-color">
//                 {moment(message.created_at).local().format("hh:mm A")}
//               </span>
//             </div>
//           </div>
//         </div>
//       );

//     default:
//       return (
//         <div ref={scrollRef} className="flex w-full items-start justify-start gap-2 mt-2">
//           <div className="flex flex-col items-start gap-2 rounded-lg bg-default-background px-4 py-3 shadow-sm max-w-[70%]">
//             <MessageComponent message={message.recipient || ''} />
//             <div className="flex items-end gap-1">
//               <span className="text-caption font-caption text-subtext-color">
//                 {moment(message.created_at).local().format("hh:mm A")}
//               </span>
//             </div>
//           </div>
//         </div>
//       );
//   }
// };

// export default Recipient;




import React, { useState } from 'react';
import SubframeCore from "@subframe/core";
// import { Progress } from "@/subframe/components/Progress";
import { IconButton } from "@/subframe/components/IconButton";
import moment from "moment";
import MessageComponent from "../MessageComponent";
// import { useSelector } from 'react-redux';
// import { useMediaDownload } from "../media/MediaDownloadHook";
// import { RootState } from '../../redux/store';
import { DialogLayout } from "@/subframe/layouts/DialogLayout";

interface RecipientMessage {
  message_id?: string;
  id?: string;
  recipient?: string;
  created_at: string;
  media_url?: string; // Added media_url property
  recipient_payload?: {
    entry: [{
      changes: [{
        value: {
          messages: [{
            type: "text" | "video" | "document" | "image" | "audio" | "button";
            text?: {
              body: string;
            };
            video?: {
              caption?: string;
              id?: number;
            };
            document?: {
              caption?: string;
              id?: number;
              filename?: string;
              mime_type?: string;
            };
            image?: {
              caption?: string;
              id?: number;
            };
            audio?: {
              voice: boolean;
              id?: number;
              mime_type?: string;
              duration?: number;
            };
          }]
        }
      }]
    }]
  }
}

interface RecipientProps {
  message: RecipientMessage;
  scrollRef: React.RefObject<HTMLDivElement>;
}

const Recipient: React.FC<RecipientProps> = ({ message, scrollRef }) => {
  const [showPreview, setShowPreview] = useState(false);
  const messageData = message.recipient_payload?.entry?.[0]?.changes?.[0]?.value?.messages?.[0];
  // const system_user_id = useSelector((state: RootState) => state.auth.system_user_id);
  // const { downloadMedia } = useMediaDownload();

  // Helper function to get message ID
  const getMessageId = () => {
    return message.message_id || message.id;
  };

  // Helper function to get media URL
  const getMediaUrl = () => {
    return message.media_url || `/api/media/${getMessageId()}`;
  };

  // const handleDownloadClick = async (e: React.MouseEvent) => {
  //   e.preventDefault();
  //   e.stopPropagation();
    
  //   const messageId = getMessageId();
  //   console.log('Download clicked:', { messageId, system_user_id });
    
  //   if (!system_user_id) {
  //     console.error('System user ID not available');
  //     return;
  //   }
    
  //   if (!messageId) {
  //     console.error('Message ID not available');
  //     return;
  //   }
    
  //   try {
  //     const result = await downloadMedia(messageId, system_user_id);
  //     console.log('Download result:', result);
  //   } catch (error) {
  //     console.error('Download error:', error);
  //   }
  // };

  const handlePreviewClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPreview(true);
  };

  // Helper function to render preview content for dialog
  const renderPreview = () => {
    const mediaUrl = getMediaUrl();
    if (!mediaUrl) return null;

    if (messageData?.type === 'image') {
      return (
        <img
          className="max-h-96 w-auto flex-none rounded-md shadow-lg"
          src={mediaUrl}
          alt="Preview"
        />
      );
    }

    if (messageData?.type === 'video') {
      return (
        <video
          className="max-h-96 w-auto flex-none rounded-md shadow-lg"
          controls
        >
          <source src={mediaUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (messageData?.type === 'document') {
      return (
        <div className="w-full h-96">
          <embed 
            src={mediaUrl}
            type={messageData?.document?.mime_type}
            width="100%"
            height="100%"
            className="rounded-md shadow-lg"
          />
        </div>
      );
    }

    if (messageData?.type === 'audio') {
      return (
        <audio 
          className="w-full" 
          controls
        >
          <source src={mediaUrl} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      );
    }
  };

  // Handle basic text message or when no specific message type is provided
  if (!messageData && message.recipient) {
    return (
              <div ref={scrollRef} className="flex w-full items-start justify-start gap-3 mt-3">
        <div className="flex flex-col items-start gap-3 rounded-3xl bg-gradient-to-br from-blue-50 to-indigo-100 border border-blue-200 px-6 py-5 shadow-xl max-w-[75%] hover:shadow-2xl hover:scale-[1.02] transition-all duration-300">
          <MessageComponent message={message.recipient} />
          <div className="flex items-end gap-1">
            <span className="text-caption font-caption text-subtext-color">
              {moment(message.created_at).local().format("hh:mm A")}
            </span>
          </div>
        </div>
      </div>
    );
  }

  switch (messageData?.type) {
    case 'video':
      return (
        <>
          <div ref={scrollRef} className="flex w-full flex-col items-start justify-start gap-3 mt-3">
            <div className="flex grow shrink-0 basis-0 flex-col items-end justify-center rounded-2xl border border-gray-200 bg-white/90 backdrop-blur-sm shadow-lg max-w-[75%] hover:shadow-xl transition-all duration-200">
              <div className="flex w-full flex-col items-start gap-2 px-1 py-1">
                <div className="relative flex w-full flex-col items-center justify-center gap-2 rounded-t-md bg-neutral-200 px-1 py-1">
                  <img
                    className="h-36 w-full flex-none rounded-t-sm border-b-2 border-solid border-neutral-border object-cover blur-md"
                    src={getMediaUrl()}
                    alt="video preview"
                  />
                  <button 
                    onClick={handlePreviewClick}
                    className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 backdrop-blur-md transition-transform duration-300 hover:scale-110 shadow-lg"
                  >
                    <SubframeCore.Icon
                      className="text-heading-1 font-heading-1 text-neutral-600 p-50"
                      name="FeatherArrowDownCircle"
                    />
                  </button>
                </div>
              </div>
              <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-1 px-4 pt-2 pb-1">
                <MessageComponent message={message.recipient || ''} />
                <div className="flex w-full items-center justify-end gap-1">
                  <span className="text-caption font-caption text-subtext-color">
                    {moment(message.created_at).local().format("hh:mm A")}
                  </span>
                  <div className="flex grow shrink-0 basis-0 items-center justify-end gap-1">
                    <SubframeCore.Icon
                      className="text-monospace-body font-monospace-body text-subtext-color"
                      name="FeatherVideo"
                    />
                    <span className="text-caption font-caption text-subtext-color">
                      Video message
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <DialogLayout open={showPreview} onOpenChange={setShowPreview}>
            <div className="flex h-full w-full flex-col items-start gap-6 bg-default-background px-6 py-6">
              <div className="flex w-full items-center justify-between border-b border-solid border-neutral-border pb-4">
                <div className="flex grow shrink-0 basis-0 flex-col items-start gap-1">
                  <span className="text-heading-2 font-heading-2 text-default-font">
                    Media Preview
                  </span>
                </div>
                <IconButton
                  icon="FeatherX"
                  onClick={() => setShowPreview(false)}
                />
              </div>

              <div className="relative w-full grow shrink-0 basis-0 flex-col items-center justify-center gap-4 rounded-md border border-solid border-neutral-border bg-neutral-50 px-6 py-6">
                <div className="flex flex-col items-center">
                  {renderPreview()}
                </div>
              </div>
            </div>
          </DialogLayout>
        </>
      );

    case 'document':
      return (
        <>
          <div ref={scrollRef} className="flex w-full flex-col items-start justify-center gap-4 mt-4">
            <div className="flex grow shrink-0 basis-0 flex-col items-end justify-center rounded-2xl border border-gray-200 bg-white/90 backdrop-blur-sm shadow-lg max-w-[75%] hover:shadow-xl transition-all duration-200">
              <div className="flex w-full flex-col items-start px-1 py-1">
                <div className="relative flex w-full flex-col items-center justify-center gap-2 rounded-t-md bg-neutral-200 px-1 py-1">
                  <img
                    className="h-36 w-full flex-none rounded-t-sm border-b-2 border-solid border-neutral-border object-cover blur-md"
                    src={getMediaUrl()}
                    alt="document preview"
                  />
                  <button 
                    onClick={handlePreviewClick}
                    className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 backdrop-blur-md transition-transform duration-300 hover:scale-110 shadow-lg"
                  >
                    <SubframeCore.Icon
                      className="text-heading-1 font-heading-1 text-neutral-600 p-50"
                      name="FeatherArrowDownCircle"
                    />
                  </button>
                </div>
                <div className="flex w-full items-center gap-2 rounded-b-md bg-neutral-200 px-2 pt-1 pb-2.5">
                  <SubframeCore.Icon
                    className="text-heading-1 font-heading-1 text-default-font"
                    name="FeatherFile"
                  />
                  <div className="flex flex-col items-start">
                    <span className="text-body-bold font-body-bold text-default-font">
                      {messageData.document?.filename || "Document"}
                    </span>
                    <span className="text-caption font-caption text-subtext-color">
                      {messageData.document?.mime_type?.split('/')[1].toUpperCase()}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-1 px-4 pt-2 pb-1">
                <MessageComponent message={message.recipient || ''} />
                <span className="text-caption font-caption text-subtext-color">
                  {moment(message.created_at).local().format("hh:mm A")}
                </span>
              </div>
            </div>
          </div>

          <DialogLayout open={showPreview} onOpenChange={setShowPreview}>
            <div className="flex h-full w-full flex-col items-start gap-6 bg-default-background px-6 py-6">
              <div className="flex w-full items-center justify-between border-b border-solid border-neutral-border pb-4">
                <div className="flex grow shrink-0 basis-0 flex-col items-start gap-1">
                  <span className="text-heading-2 font-heading-2 text-default-font">
                    Media Preview
                  </span>
                </div>
                <IconButton
                  icon="FeatherX"
                  onClick={() => setShowPreview(false)}
                />
              </div>

              <div className="relative w-full grow shrink-0 basis-0 flex-col items-center justify-center gap-4 rounded-md border border-solid border-neutral-border bg-neutral-50 px-6 py-6">
                <div className="flex flex-col items-center">
                  {renderPreview()}
                </div>
              </div>
            </div>
          </DialogLayout>
        </>
      );

    case 'image':
      return (
        <>
          <div ref={scrollRef} className="flex w-full flex-col items-start justify-center gap-4 mt-4">
            <div className="flex grow shrink-0 basis-0 flex-col items-end justify-center rounded-2xl border border-gray-200 bg-white/90 backdrop-blur-sm shadow-lg max-w-[75%] hover:shadow-xl transition-all duration-200">
              <div className="flex w-full flex-col items-start gap-2 px-1 py-1">
                <div className="relative flex w-full flex-col items-center justify-center gap-2 rounded-t-md bg-neutral-200 px-1 py-1">
                  <img
                    className="h-36 w-full flex-none rounded-t-sm border-b-2 border-solid border-neutral-border object-cover blur-md"
                    src={getMediaUrl()}
                    alt="image preview"
                  />
                  <button 
                    onClick={handlePreviewClick}
                    className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 p-2 rounded-full bg-white/80 backdrop-blur-md transition-transform duration-300 hover:scale-110 shadow-lg"
                  >
                    <SubframeCore.Icon
                      className="text-heading-1 font-heading-1 text-neutral-600 p-50"
                      name="FeatherArrowDownCircle"
                    />
                  </button>
                </div>
              </div>
              <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-1 px-4 pt-2 pb-1">
                <MessageComponent message={message.recipient || ''} />
                <div className="flex w-full items-center justify-end gap-1">
                  <span className="text-caption font-caption text-subtext-color">
                    {moment(message.created_at).local().format("hh:mm A")}
                  </span>
                  <div className="flex grow shrink-0 basis-0 items-center justify-end gap-1">
                    <SubframeCore.Icon
                      className="text-monospace-body font-monospace-body text-subtext-color"
                      name="FeatherImage"
                    />
                    <span className="text-caption font-caption text-subtext-color">
                      Image message
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <DialogLayout open={showPreview} onOpenChange={setShowPreview}>
            <div className="flex h-full w-full flex-col items-start gap-6 bg-default-background px-6 py-6">
              <div className="flex w-full items-center justify-between border-b border-solid border-neutral-border pb-4">
                <div className="flex grow shrink-0 basis-0 flex-col items-start gap-1">
                  <span className="text-heading-2 font-heading-2 text-default-font">
                    Media Preview
                  </span>
                </div>
                <IconButton
                  icon="FeatherX"
                  onClick={() => setShowPreview(false)}
                />
              </div>

              <div className="relative w-full grow shrink-0 basis-0 flex-col items-center justify-center gap-4 rounded-md border border-solid border-neutral-border bg-neutral-50 px-6 py-6">
                <div className="flex flex-col items-center">
                  {renderPreview()}
                </div>
              </div>
            </div>
          </DialogLayout>
        </>
      );

    case 'audio':
      return (
        <div ref={scrollRef} className="flex w-full items-start justify-start gap-2 mt-2">
          <div className="flex w-full max-w-[75%] flex-col items-start gap-3 rounded-2xl border border-gray-200 bg-white/90 backdrop-blur-sm px-5 py-4 shadow-lg hover:shadow-xl transition-all duration-200">
            <audio 
              className="w-full" 
              controls
              src={getMediaUrl()}
              preload="metadata"
            >
              Your browser does not support the audio element.
            </audio>
            <div className="flex w-full items-center gap-2">
              <SubframeCore.Icon
                className="text-body font-body text-subtext-color"
                name="FeatherMic"
              />
              <span className="grow shrink-0 basis-0 text-body font-body text-default-font">
                Voice message
              </span>
              <span className="text-caption font-caption text-subtext-color">
                {moment(message.created_at).local().format("hh:mm A")}
              </span>
            </div>
          </div>
        </div>
      );

    default:
      return (
        <div ref={scrollRef} className="flex w-full items-start justify-start gap-2 mt-2">
          <div className="flex flex-col items-start gap-2 rounded-lg bg-default-background px-4 py-3 shadow-sm max-w-[70%]">
            <MessageComponent message={message.recipient || ''} />
            <div className="flex items-end gap-1">
              <span className="text-caption font-caption text-subtext-color">
                {moment(message.created_at).local().format("hh:mm A")}
              </span>
            </div>
          </div>
        </div>
      );
  }
};

export default Recipient;